var linkBg = "/static/e067a32165c9ad19.png";

export { linkBg as default };
//# sourceMappingURL=shadow.png.js.map
